module.exports = __webpack_public_path__ + "static/media/calendar-green.56107764.svg";